import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M12 2.25a.75.75 0 0 1 .75.75v2.25H17a2.75 2.75 0 0 1 1.578.498l3.43 2.322c.459.323.742.87.742 1.43 0 .569-.29 1.113-.754 1.44l-3.418 2.313A2.75 2.75 0 0 1 17 13.75h-4.25v7.5H16a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1 0-1.5h3.25v-7.5H4A1.75 1.75 0 0 1 2.25 12V7A1.75 1.75 0 0 1 4 5.25h7.25V3a.75.75 0 0 1 .75-.75m-8 4.5a.25.25 0 0 0-.25.25v5a.25.25 0 0 0 .25.25h13c.258 0 .51-.08.72-.228l.012-.008 3.416-2.312a.25.25 0 0 0 .102-.201.25.25 0 0 0-.102-.202l-3.428-2.32A1.25 1.25 0 0 0 17 6.75z"
      clipRule="evenodd"
    />
  </>
);

const Signpost = Icon('signpost', svgContents);

export default Signpost;
